<div class="content-renderer">
    @switch (content().type) {
        <!-- Text Content -->
        @case ('text') {
            <div class="text-content">
                @if (content().metadata?.title) {
                    <h4 class="content-title">{{ content().metadata?.title }}</h4>
                }
                <div class="text-body" [ngClass]="{'edit-message': !isBotMessage}">
                    <div class="streaming-container">
                        <span [innerHTML]="formatText(displayedText)"></span>
                        @if (isStreaming) {
                            <span class="typing-cursor">|</span>
                        }
                    </div>
                </div>
            </div>
        }

        <!-- Table Content -->
        @case ('table') {
            <div class="table-content">
                @if (content().metadata?.title) {
                    <div class="table-header">
                        <h4 class="content-title">{{ content().metadata?.title }}</h4>
                        <button class="copy-button" (click)="copyToClipboard(getTableAsText())">
                        </button>
                    </div>
                }

                <div class="table-container">
                    <table class="chat-table">
                        <thead>
                            <tr>
                                @for (header of content().data.headers; track $index) {
                                    <th>{{ header }}</th>
                                }
                            </tr>
                        </thead>
                        <tbody>
                            @for (row of content().data.rows; track $index) {
                                <tr>
                                    @for (cell of row; track $index) {
                                        <td>{{ cell }}</td>
                                    }
                                </tr>
                            }
                        </tbody>
                    </table>
                </div>
            </div>
        }

        <!-- List Content -->
        @case ('list') {
            <div class="list-content">
                @if (content().metadata?.title) {
                    <h4 class="content-title">{{ content().metadata?.title }}</h4>
                }

                @if (content().data?.type === 'unordered') {
                    <ul class="unordered-list">
                        @for (item of content().data?.items; track $index) {
                            <li>
                                <span [innerHTML]="formatText(item)"></span>
                            </li>
                        }
                    </ul>
                }

                @if (content().data?.type === 'ordered') {
                    <ol class="ordered-list">
                        @for (item of content().data?.items; track $index) {
                            <li>
                                <span [innerHTML]="formatText(item)"></span>
                            </li>
                        }
                    </ol>
                }
            </div>
        }

        <!-- Code Content -->
        @case ('code') {
            <div class="code-content">
                <div class="code-header">
                    @if (content().metadata?.title) {
                        <h4 class="content-title">{{ content().metadata?.title }}</h4>
                    }
                    <div class="code-actions">
                        @if (content().metadata?.language) {
                            <span class="language-tag">{{ content().metadata?.language }}</span>
                        }
                        <button class="copy-button" (click)="copyToClipboard(content().data)">
                        </button>
                    </div>
                </div>

                <div class="code-block">
                    <div class="streaming-container">
                        <pre><code [class]="'language-' + (content().metadata?.language || 'text')">{{ displayedText }}@if (isStreaming) {<span class="typing-cursor">|</span>}</code></pre>
                    </div>
                </div>
            </div>
        }

        <!-- Markdown Content -->
        @case ('markdown') {
            <div class="markdown-content">
                @if (content().metadata?.title) {
                    <h4 class="content-title">{{ content().metadata?.title }}</h4>
                }
                <div class="markdown-body">
                    <div class="streaming-container">
                        <span [innerHTML]="formatText(displayedText)"></span>
                        @if (isStreaming) {
                            <span class="typing-cursor">|</span>
                        }
                    </div>
                </div>
            </div>
        }

        <!-- HTML Content -->
        @case ('html') {
            <div class="html-content">
                @if (content().metadata?.title) {
                    <div class="html-header">
                        <h4 class="content-title">{{ content().metadata?.title }}</h4>
                        <button class="copy-button" title="click to copy" (click)="copyToClipboard(content().data)">
                            <span>Copy</span>
                        </button>
                    </div>
                }
                <div class="html-body" [innerHTML]="getSafeHtml(content().data)"></div>
            </div>
        }

        <!-- Default/Unknown Content -->
        @default {
            <div class="default-content">
                @if (content().metadata?.title) {
                    <h4 class="content-title">{{ content().metadata?.title }}</h4>
                }
                <div class="default-body">
                    <pre>{{ content().data | json }}</pre>
                </div>
            </div>
        }
    }
</div>